import { render, staticRenderFns } from "./UniqueSellingPoint.vue?vue&type=template&id=6565df88&"
import script from "./UniqueSellingPoint.js?vue&type=script&lang=js&"
export * from "./UniqueSellingPoint.js?vue&type=script&lang=js&"
import style0 from "./UniqueSellingPoint.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports